import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import styles from "./style.module.scss";
import { Icons } from "assets";
import { bookTypes, quiz, language, hardCopy, newArrivals } from "./constant";
import {
  getAllAgeRangesService,
  getGenresService,
} from "shared/services/general";
import classNames from "classnames";
import DoneIcon from "@mui/icons-material/Done";

function BooksFilter() {
  const [genresFilter, setGenresFilter] = useState<any>([]);
  const [ageRangeFilter, setAgeRangeFilter] = useState<any>([]);
  const [bookTypeFilter, setBookTypeFilter] = useState<any>(bookTypes);
  const [quizFilter, setQuizFilter] = useState<any>(quiz);
  const [languageFilter, setLanguageFilter] = useState<any>(language);
  const [hardCopyFilter, setHardCopyFilter] = useState<any>(hardCopy);
  const [newArrivalsFilter, setNewArrivalsFilter] = useState<any>(newArrivals);

  const getAllGenres = () => {
    getGenresService()
      .then(({ data: { data } }) => {
        setGenresFilter(
          data?.map((item: any) => ({
            ...item,
            label: item?.name,
            selected: false,
          }))
        );
      })
      .catch((err) => {});
  };

  const getAllAgeRanges = () => {
    getAllAgeRangesService()
      .then(({ data: { data } }) => {
        setAgeRangeFilter(
          data?.map((item: any) => ({
            ...item,
            label: item?.text,
            selected: false,
          }))
        );
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getAllGenres();
    getAllAgeRanges();
  }, []);

  const handleResetFilters = () => {
    setBookTypeFilter(bookTypes);
    setQuizFilter(quiz);
    setLanguageFilter(language);
    setHardCopyFilter(hardCopy);
    setNewArrivalsFilter(newArrivals);
    setGenresFilter(
      genresFilter?.map((item: any) => ({
        ...item,
        selected: false,
      }))
    );
    setAgeRangeFilter(
      ageRangeFilter?.map((item: any) => ({
        ...item,
        selected: false,
      }))
    );
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.filterContianer}>
        <FilterButton
          label="Book Type"
          isSortLabel
          menuItems={bookTypeFilter}
          setState={setBookTypeFilter}
        />
        <FilterButton
          label="Genre"
          menuItems={genresFilter}
          setState={setGenresFilter}
        />
        <FilterButton
          label="Quiz"
          menuItems={quizFilter}
          setState={setQuizFilter}
        />
        <FilterButton
          label="Language"
          menuItems={languageFilter}
          setState={setLanguageFilter}
        />
        <FilterButton
          label="Hard-Copy"
          menuItems={hardCopyFilter}
          setState={setHardCopyFilter}
        />
        <FilterButton
          label="Age Group"
          menuItems={ageRangeFilter}
          setState={setAgeRangeFilter}
        />
        <FilterButton
          label="New Arrival"
          menuItems={newArrivalsFilter}
          setState={setNewArrivalsFilter}
        />
        <button
          className={styles.resetFilter2}
          onClick={() => handleResetFilters()}
        >
          Reset Filter
        </button>
      </div>
      <button
        className={styles.resetFilter}
        onClick={() => handleResetFilters()}
      >
        Reset Filter
      </button>
    </div>
  );
}

export default BooksFilter;

function FilterButton({ label, isSortLabel, menuItems, setState }: any) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelection = (item: any) => {
    const updatedMenuItems = menuItems.map((itm: any) =>
      itm.id === item.id ? { ...itm, selected: !itm.selected } : itm
    );
    setState(updatedMenuItems);
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        className={styles.filterBtn}
      >
        {isSortLabel ? (
          <label className={styles.sortByLabel}>Sort by </label>
        ) : (
          ""
        )}
        {label}
        <Icons.DropDownIcon />
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        PaperProps={{
          sx: {
            boxShadow: "none",
            border: "1px solid #e2e2e2",
            padding: "0px 10px",
            background: "white",
          },
          className: styles.paperFlow,
        }}
      >
        {menuItems?.map((item: any) => {
          return (
            <MenuItem
              className={classNames(
                item?.selected && styles.selected,
                styles.menuItems
              )}
              onClick={() => handleSelection(item)}
            >
              <div
                className={classNames(
                  styles.checkbox,
                  item?.selected && styles.checked
                )}
              >
                {item?.selected && (
                  <DoneIcon
                    sx={{
                      color: "white",
                      height: "12px",
                      width: "12px",
                    }}
                  />
                )}
              </div>
              {item?.label}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
}
